import { setReducer } from "../../reducer/creators"
import { WindowState } from "../WindowState"
import { SET_WINDOW } from "../actions"

export const window = setReducer<WindowState>([SET_WINDOW], { height: global.window.innerHeight, width: global.window.innerWidth })
